import { Component } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { mixins } from "vue-class-component";
import PusherSocket from "@/helpers/socket/pusher.socket";
import Loader from "@/resources/mixins/loader/loader";
import Chat from "@/resources/mixins/chime/chat";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import ErrorController from "@/resources/mixins/errorController/errorController";
import PhotonNotificationErrorComponent from "@/app/views/nubii/components/graphicClientOptions/photonNotificationError.component.vue";
import { Store } from "vuex";
import NextMaintenanceComponent from "@/app/views/nubii/components/nextMaintenance/nextMaintenance.component.vue";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { PLAN } from "@/resources/constants/plan";
import Plans from "../plans/plans";

const SHOW_WARNING = 5;

@Component({})
export default class LoadApp extends mixins(
  PusherSocket,
  Loader,
  Chat,
  NotificationEvent,
  ErrorController,
  Plans
) {
  PPLAN = PLAN;
  countScript = 0;
  retryCountLoadGraphicalClient = 0;
  $store: Store<any>;
  /**
   * Provisional hasta encontrar otra solución
   */
  async setStore($store: Store<any>): Promise<void> {
    this.$store = $store;
  }
  /**
   * Se crea la instancia de pusher despues de cargar todos los scripts
   * */
  async createPusherAction(): Promise<void> {
    await this.createPusher()
      .then((result) => {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("createPusher ok");
        this.subscribeToSystem();
        this.getGlobalParams();
      })
      .catch((error) => {
        /* Si no se pudo crear la instancia, se vuelve a intentar a los 2 segundos*/
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("CREATE PUSHER ERROR");
        setTimeout(() => {
          this.createPusherAction();
        }, 2000);
      });
  }
  async getGlobalParams(): Promise<void> {
    await this.$store.dispatch("SpaceStore/getGlobalParamsAction", {
      callback: async (response) => {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("GLOBAL_PARAMS", response);
        localStorage.setItem(
          "SPEED_NETWORKING_WAITING_TIME_BETWEEN_CYCLES",
          response.data.SPEED_NETWORKING_WAITING_TIME_BETWEEN_CYCLES ?? "15"
        );
        localStorage.setItem("isAiActicated", response.data.IS_AI_ACTIVATED);
        localStorage.setItem("WEB_CLIENT_LOG_ACTIVATED", response.data.WEB_CLIENT_LOG_ACTIVATED);
        if (response.data.MAINTENANCE_STATUS == "ON") {
          await this.$store.dispatch(
            "SystemStore/setMaintenanceStartAction",
            response.data.MAINTENANCE_START_AT
          );
          await this.$store.dispatch(
            "SystemStore/setMaintenaceFinishAction",
            response.data.MAINTENANCE_FINISH_AT
          );
          localStorage.setItem("maintenance", "on");
          await this.$store.dispatch(
            "SystemStore/setMaintenanceModalAction",
            true
          );
          this.stopLoader(this.$store);
          await this.getUser();
          return;
        } else if (
          response.data.MAINTENANCE_STATUS == "OFF" &&
          response.data.NEXT_MAINTENANCE_AT != null
        ) {
          this.$store.dispatch(
            "FloatMenuStore/setTimeNextMaintenanceAction",
            response.data.NEXT_MAINTENANCE_AT
          );
          this.$store.dispatch(
            "FloatMenuStore/setShowNextMaintenanceAction",
            true
          );
        }
        const nubiiVersion = localStorage.getItem("nubii_version");
        if (nubiiVersion) {
          if (nubiiVersion != response.data.NUBII_VERSION) {
            localStorage.setItem("nubii_version", response.data.NUBII_VERSION);
            window.location.reload();
            return;
          }
        } else
          localStorage.setItem("nubii_version", response.data.NUBII_VERSION);

        await this.loadFirstTime();
      },
      callbackError: (error) => {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("getGlobalParams", error);
        if (error.response && error.response.status == 500) {
          this.stopLoader(this.$store);
          this.$store.dispatch("SystemStore/setMaintenanceMessageError", true);
          this.$store.dispatch("SystemStore/setMaintenanceModalAction", true);
          setTimeout(() => {
            window.location.reload();
          }, 300000);
        }
      },
    });
  }

  /**
   * Se cargar todos los datos necesarios para el cliente grafico
   * */
  async loadFirstTime(): Promise<void> {
    await this.startLoader(this.$store);
    if (localStorage.getItem("city") == "OFF") await this.getSpaceAvailable();
    else {
      await this.$store.dispatch("UserStore/getUserAction", {
        callback: async (response) => {
          /*this.$store.dispatch(
            "SystemStore/setShowCameraOptionsAction",
            localStorage.getItem("camera_options") !== "false"
          );*/
        },
      });
      await this.loadGraphicClientInitializer();
    }
    const unSeenMessage = JSON.parse(localStorage.getItem("unSeenMessage"));
    await this.$store.dispatch(
      "ChatStore/setUnSeenMessageAction",
      unSeenMessage ? unSeenMessage : []
    );
    //TODO DELETE NOTIFICATION MESSAGE ROOM
    this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
      id: null,
      type: CHAT_TYPE.ROOM,
    });
  }

  async getSpaceAvailable(): Promise<void> {
    this.setLoaderText(this.$store, i18n.t("loader.loadingSpaces").toString());
    const spaceId = localStorage.getItem("space_default");
    if (spaceId) {
      setTimeout(async () => {
        await this.getSpace(parseInt(spaceId));
      }, 3500);
    }
    /*await this.$store.dispatch("SpaceStore/getSpacesAvailableAction", {
      callback: (spaceId) => {
        setTimeout(async () => {
          this.setLoaderText(
            this.$store,
            i18n.t("loader.loadingUser").toString()
          );
          await this.getSpace(spaceId);
        }, 3500);
      },
      callbackError: (error) => {
        if (error == "logout") {
          this.$store.dispatch("AuthStore/logOutAction");
          return;
        }
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
      },
    });*/
  }

  async getUser(): Promise<void> {
    await this.$store.dispatch("UserStore/getUserAction", {
      callback: async (response) => {
        if (response.isNubiiAdmin) {
          localStorage.setItem("maintenance", "on");
          await this.$store.dispatch(
            "SystemStore/setMaintenanceModalAction",
            false
          );
          this.startLoader(this.$store);
          await this.loadFirstTime();
        }
      },
    });
  }

  /**
   * Busca la data del espacio
   * */
  async getSpace(spaceId: number): Promise<void> {
    await this.$store.dispatch("SpaceStore/getSpaceAction", {
      spaceId,
      callback: async (response) => {
        if (
          (response.usersConnected != 0 &&
            response.usersConnected >= response.usersConnectedLimit) ||
          (response.superSpace.usersConnected >= response.superSpace.usersConnectedLimit)
        ) {
          this.onWarning("", i18n.t("notifications.descriptions.spaceFull"));
          if (response.superSpace.totalSpaces < 1) {
            setTimeout(() => {
              localStorage.removeItem("space_default");
              localStorage.setItem("city", "ON");
              window.location.reload();
            }, 3000);
          } else {
            await this.$store.dispatch(
              "SpaceStore/setSpacesAvailablePageAction",
              1
            );
            await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
            await this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
              id: response.superSpace.id,
              callback: () => {
                this.$store.dispatch(
                  "SystemStore/setOpenChangeSpaceModalAction",
                  true
                );
              },
              callbackError: (error) => {
                // do nothing
              },
            });
          }
          return;
        }
        await this.getSpaceUser(response.superSpace.id, response.id);
        //// CHECK THAT IT IS A TEAMS SPACE OR IS FROM IPAD ////
        if (
          response?.superSpace?.isTeams ||
          localStorage.getItem("deviceType") === "TABLET"
        )
          this.$store.dispatch("SidebarStore/setActiveMenuAction", -1);
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        if (error.response && error.response.status == 403) {
          this.checkError(error);
          setTimeout(() => {
            localStorage.removeItem("space_default");
            localStorage.setItem("city", "ON");
            window.location.reload();
          }, 3000);
        } else {
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
          setTimeout(() => {
            localStorage.removeItem("space_default");
            localStorage.setItem("city", "ON");
            window.location.reload();
          }, 3000);
        }
      },
    });
  }
  /**
   * Busca la data del spaceUser para el usuario logueado en el espacio
   * */
  async getSpaceUser(superSpaceId: number, spaceId: number): Promise<void> {
    await this.$store.dispatch("UserStore/getSpaceUserAction", {
      spaceId,
      callback: async (user: SpaceUserInterface) => {
        this.setLoaderText(
          this.$store,
          i18n.t("loader.connectingServices").toString()
        );

        const hasOnboarding = !localStorage.getItem("hasOnboarding")
          ? true
          : localStorage.getItem("hasOnboarding") === "true";
        if (!user.superSpaceUser.user.isFirstTime)
          await this.connectToPusher(superSpaceId, spaceId);
        else {
          if (!hasOnboarding) {
            await this.connectToPusher(superSpaceId, spaceId);
          }
          await this.loadGraphicClientInitializer();
          let isTeams = localStorage.getItem("isTeams");
          if (isTeams)
            await this.$store.dispatch(
              "SystemStore/setShowCompleteOnBoardingTeamsAction",
              user.superSpaceUser.user.isFirstTime
            );
          else
            await this.$store.dispatch(
              "SystemStore/setShowCompleteOnBoardingAction",
              user.superSpaceUser.user.isFirstTime
            );
        }
        //LOAD POWER_UP NOTIFICATIONS
        if (process.env.VUE_APP_ENVIRONMENT === "PRO") {
          await this.$store.dispatch(
            "SidebarStore/getPowerUpsNotificationsAction",
            {
              userId: user.superSpaceUser.user.id,
              spaceId: spaceId,
            }
          );
        }
        ////////////////////////////
        this.$store.dispatch(
          "SystemStore/setShowCameraOptionsAction",
          localStorage.getItem("camera_options") !== "false"
        );
      },
    });
  }

  /**
   * Inicializa la conexion con pusher
   * */
  async connectToPusher(superSpaceId: number, spaceId: number): Promise<void> {
    this.setConnectionStarted(true);
    await this.subscribe()
      .then((result) => {
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("connectToPusher subscribe ok ", result);
        this.setConnectionStarted(false);
        this.connectionCompleted(superSpaceId, spaceId);
      })
      .catch((error) => {
        /* Si no se pudo conectar vuelve a intentarlo a los 20seg*/
        if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
          console.log("connectToPusher subscribe  ", error);
        setTimeout(async () => {
          if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
            console.log("connectToPusher RETRY");
          await this.connectToPusher(superSpaceId, spaceId);
        }, 20000);
      });
  }
  /**
   * Comprueba la conexión con pusher
   * */
  async connectionCompleted(
    superSpaceId: number,
    spaceId: number
  ): Promise<void> {
    this.setLoaderText(this.$store, i18n.t("loader.loadingUsers").toString());
    await this.$store.dispatch("SpaceStore/setUsersInSpacePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageUserAction", 2);
    await this.$store.dispatch("SpaceStore/getSpaceUsersAction", {
      superSpaceId,
      callback: () => null,
    });
    await this.$store.dispatch("ChatStore/getEndPointUrlAction", {
      callback: async () => {
        await this.createMessaging();
        if (!this.activeOptionPlan(PLAN.GENERAL_CHAT)) {
          return;
        }
        await this.$store.dispatch("ChatStore/joinSpaceChatAction", spaceId);
      },
    });
    await this.loadGraphicClientInitializer();
  }
  /**
   * Carga el cliente grafico
   * */
  async loadGraphicClientInitializer(): Promise<void> {
    if (window["graphicClientInitializer"] != undefined) {
      this.setLoaderText(
        this.$store,
        i18n.t("loader.preparingSpace").toString()
      );
      await window["graphicClientInitializer"]();
    } else {
      if (process.env.VUE_APP_ENVIRONMENT !== "PRO")
        console.log("LOAD loadGraphicClientInitializer error ");
      if (this.retryCountLoadGraphicalClient < SHOW_WARNING) {
        setTimeout(() => {
          this.loadGraphicClientInitializer();
        }, 2000);
      }
      this.checkGraphicalClientLoad();
    }
  }

  /**
   * Comprueba que se haya cargado el cliente grafico
   * */
  checkGraphicalClientLoad(): void {
    if (this.retryCountLoadGraphicalClient == SHOW_WARNING) {
      this.$vs.notification({
        duration: "none",
        color: "danger",
        clickClose: true,
        content: PhotonNotificationErrorComponent,
        onDestroy: () => {
          window.location.reload();
        },
      });
    }
    this.retryCountLoadGraphicalClient++;
    return;
  }
}
